//import Notiflix from 'notiflix';
import { Notify } from 'notiflix/build/notiflix-notify-aio'

export default class Pdf {
  constructor(user, btn) {
    this.user = user
    this.btn = btn
    this.elements = document.querySelectorAll('.generatePdfAction')
    window.addEventListener('load', () => {
      this.init()
    })
  }

  init() {
    this.elements = document.querySelectorAll('.generatePdf')
    this?.btn?.addEventListener('click', (event) => this.generatePDF(event))
    // this.elements.forEach((element) => {
    //   element.addEventListener('click', (event) => this.generatePDF(event))
    // })
  }

  toggleLoading() {
    this.elements?.forEach((element) => {
      element.classList.toggle('load')
    })
  }

  generatePDF(event) {
    event.preventDefault()
    const postID = event.currentTarget.dataset.postid
    const pdfnonce = event.currentTarget.dataset.pdfnonce
    this.toggleLoading()

    // window.dataLayer.push({
    // 	event: 'DownloadPDF',
    // 	subscribed: 'yes',
    // });

    //check sull'oggetto subscription che controlla se l'utente può il
    Notify.warning(lgc_global.action_messages.pdf_start)

    wp.ajax
      .post('legc_pdf_download', {
        postID,
        pdfnonce,
      })
      .done((data) => {
        this.toggleLoading()
        Notify.success(data.message)
        this.download(data.download_link, data.filename)
      })
      .fail((error) => {
        this.toggleLoading()
        Notify.failure(error.message)
      })
  }

  download(url, filename) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Server returned ${response.status}`)
        }
        const contentType = response.headers.get('Content-Type') || ''
        if (!contentType.includes('application/pdf')) {
          throw new Error(`Unexpected content type: ${contentType}`)
        }
        return response.blob()
      })
      .then((blob) => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      })
      .catch((error) => {
        console.log('Looks like there was a problem: ', error)
        Notify.failure(lgc_global.action_messages.pdf_error_download)
      })
  }
}
